import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{backgroundColor:"#4d43486a", backdropFilter:"blur(20px)"}}>
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Temperstack Inc</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Crafted with{" "}<i className="mdi mdi-heart text-danger"></i>.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
